import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  Paper,
  TableBody,
} from '@mui/material';

import { Chip } from '../../../components/common';
import {
  TableRow as StyledTableRow,
  TableCell as StyledTableCell,
} from '../../../components/common/Table';
import { downloadBase64Attachment } from '../../../utils/utils';

export default function FinancialBurdenTable(props) {
  let burdenSum = 0;
  props.data?.forEach((row) => (burdenSum += row.amount));

  return (
    <>
      <Grid container sx={{ mt: 4 }}>
        <Grid item xs={12} ref={props.cropsStructureTableRef}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="financialBurdenTable">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Nazwa obciążenia</StyledTableCell>
                  <StyledTableCell align="center">
                    Pełna kwota obciązenia
                  </StyledTableCell>
                  <StyledTableCell align="center">% Obciążenia</StyledTableCell>
                  <StyledTableCell align="center">
                    Długość obciążenia (w latach)
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Data zakończenia
                  </StyledTableCell>
                  <StyledTableCell align="center">Załączniki</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.data
                  ?.sort((a, b) => a.id - b.id)
                  .map((row) => (
                    <StyledTableRow
                      key={row.name + row.amount + '_financial_burden'}
                    >
                      <StyledTableCell component="th" scope="row">
                        {row.name}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.amount}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {Number(row.percentageValue.toFixed(2))}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.liabilityLength}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.finishDate[2] +
                          '.' +
                          row.finishDate[1] +
                          '.' +
                          row.finishDate[0]}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.file !== null && (
                          <Chip
                            label={row.fileName}
                            onClick={() =>
                              downloadBase64Attachment(
                                row.file,
                                row.fileExtension,
                                row.fileName
                              )
                            }
                          />
                        )}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid
          item
          xs={12}
          container
          justifyContent="right"
          alignContent="right"
        >
          <Grid item xs={3} sx={{ my: 4 }}>
            <TableContainer>
              <Table sx={{ width: '100%' }}>
                <TableHead>
                  <TableRow
                    style={{ boxShadow: '0px 1px 18px rgba(0, 0, 0, 0.12)' }}
                  >
                    <StyledTableCell
                      variant="head"
                      style={{
                        borderRadius: '6px 0px 0px 6px',
                        width: '50%',
                      }}
                    >
                      Suma obciążeń (zł)
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        borderRadius: '0px 6px 6px 0px',
                        width: '50%',
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        color: '#000000',
                      }}
                    >
                      {burdenSum || '-'}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
